import React, { useState } from "react";

import FavoriteToggleButton from "./FavoriteToggleButton";

const HomeSectionGameCard = ({
  item,
  index = 0,
  isLaunching = false,
  isFavorite = false,
  onFavoriteToggle,
  onLaunch,
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const hasImage = item?.image && !imageFailed;
  const title = item?.title || "게임";

  return (
    <div className="backend-card-shell">
      <button
        type="button"
        className="backend-card-link backend-card-button recent-play-card-wrap"
        onClick={() => onLaunch?.(item)}
        aria-label={`${title} 실행`}
      >
        <article className={`backend-card ${hasImage ? "has-image" : "no-image"}`}>
          {hasImage ? (
            <img
              src={item.image}
              alt={title}
              loading={index < 4 ? "eager" : "lazy"}
              onError={() => setImageFailed(true)}
            />
          ) : null}
          <div className="backend-card-title">
            <strong>{title}</strong>
          </div>
          <div className="backend-card-hover-layer">
            <span className="backend-card-play" aria-hidden="true" />
            <strong>{isLaunching ? "실행 중" : title}</strong>
          </div>
        </article>
        <span className="recent-play-meta">
          <span className="live-dot" />
          {item?.meta || "플레이 가능"}
        </span>
      </button>

      <FavoriteToggleButton
        active={isFavorite}
        label={title}
        onToggle={() => onFavoriteToggle?.(item)}
      />
    </div>
  );
};

export default HomeSectionGameCard;
